import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID, signal, Type } from '@angular/core';
import { SerializedData } from 'in-time-core';

@Injectable({ providedIn: 'root' })
export class DialogService {
  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  // Holds the component type to be rendered inside the dialog
  activeComponent = signal<Type<unknown> | null>(null);

  // Optional: Pass data to the dialog
  dialogData = signal<SerializedData | null>(null);

  open<T>(component: Type<T>, data?: SerializedData) {
    if(!this.isBrowser) return; // Prevent dialog operations on the server

    this.dialogData.set(data ?? null);
    this.activeComponent.set(component);
  }

  close() {
    if(!this.isBrowser) return; // Prevent dialog operations on the server

    this.activeComponent.set(null);
    this.dialogData.set(null);
  }
}
